import React, {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
// import {toast} from 'react-toastify'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
import {CheckboxField, KTSVG, Model} from 'helpers'
import {Select2DropdownField} from 'helpers/ui-components/form/Select2DropdownField'
import IDropdown from 'models/dropdown'
import {ColumnProps, IFormField} from 'models/Common'
import KTTable from 'helpers/ui-components/KTTable'
import {
 fetchDistrict,
 fetchState,
} from 'utils/api/auth/locationService'
import {IUser} from 'models/UserManagement'
import {
 fetchAssignedSubDistrictList,
 createGeoMapping,
 fetchAssignedDistrictList,
 fetchAssignedStateList,
 fetchGeoMapping,
} from 'utils/api/auth/userManagementService'
import {toast} from 'react-toastify'
import {KTSearchBox} from 'helpers/ui-components/KTSearchBox'
import {Link} from 'react-router-dom'
import {KTConfirmPopup} from 'helpers/ui-components/KTConfirmPopup'
// import {ILogin} from 'models/Auth'
type IProps = {
 accessDetails: IFormField | undefined
 userDetails?: IFormField | null
 userRole: string
 loggedInUserId: number | undefined
 setLoader: (newState: boolean) => void
}

type ITableData = {
 users: IUser[]
 id: string
 name: string
 is_active?: boolean
 is_mapped?: boolean
}

type GeoLevel =
 | 'subDistrict'
 | 'district'
 | 'state'
 | 'rbmState'

const getGeoLevel = (userRole: string): GeoLevel => {
 if (['dl', 'mlc'].includes(userRole)) {
  return 'subDistrict'
 }
 if (
  ['sr_dl', 'sr_mlc_fv', 'sr_mlc_dry'].includes(userRole)
 ) {
  return 'district'
 }
 if (userRole === 'rbm') {
  return 'rbmState'
 }
 return 'state'
}

type GeoLevelConfig = {
 showStateDropdown: boolean
 showDistrictDropdown: boolean
 showLoadButton: boolean
 autoLoadAssignedList: boolean
 usesSelectedIdsAsStates: boolean
 labelKey: 'state' | 'district' | 'subDistrict'
}

const GEO_LEVEL_CONFIG: Record<GeoLevel, GeoLevelConfig> = {
 state: {
  showStateDropdown: true,
  showDistrictDropdown: false,
  showLoadButton: false,
  autoLoadAssignedList: false,
  usesSelectedIdsAsStates: false,
  labelKey: 'state',
 },
 district: {
  showStateDropdown: true,
  showDistrictDropdown: false,
  showLoadButton: true,
  autoLoadAssignedList: false,
  usesSelectedIdsAsStates: false,
  labelKey: 'district',
 },
 subDistrict: {
  showStateDropdown: true,
  showDistrictDropdown: true,
  showLoadButton: true,
  autoLoadAssignedList: false,
  usesSelectedIdsAsStates: false,
  labelKey: 'subDistrict',
 },
 rbmState: {
  showStateDropdown: false,
  showDistrictDropdown: false,
  showLoadButton: false,
  autoLoadAssignedList: true,
  usesSelectedIdsAsStates: true,
  labelKey: 'state',
 },
}

const GeographyMapping = (props: IProps) => {
 const {t} = useTranslation()
 const [isDisabled, setIsDisabled] = useState(true)
 const [confirmModalData, setConfirmModalData] =
  useState<ITableData | null>(null)
 const [tableColList, setTableColList] = useState<
  Array<ColumnProps<ITableData>>
 >([])
 const [showAddNewBtn, setShowAddNewBtn] = useState(false)
 const [showLoadMoreBtn, setShowLoadMoreBtn] =
  useState(false)
 const [showConfirmModel, setShowConfirmModel] =
  useState(false)
 const [confirmModelContent, setConfirmModelContent] =
  useState({
   title: '',
   msg: '',
   msgSub: '',
   type: '',
   value: 0,
  })
 const [searchTerm, setSearchTerm] = useState('')
 const [stateList, setStateList] = useState<IDropdown[]>([])
 const [districtList, setDistrictList] = useState<
  IDropdown[]
 >([])
 const [tableDataList, setTableDataList] = useState<
  ITableData[]
 >([])
 const [currentGeoMapping, setCurrentGeoMapping] =
  useState<IFormField | null>(null)

 const [tableRows, setTableRows] = useState<ITableData[]>(
  []
 )
 const userId = props.userDetails?.id

 const level = getGeoLevel(props.userRole)
 const levelConfig = GEO_LEVEL_CONFIG[level]
 const getLevelLabel = () =>
  t(
   `userManagement.activate.geoMappingManage.${levelConfig.labelKey}`
  )
 const getLevelNameColumnLabel = () =>
  t(
   `userManagement.activate.geoMappingManage.${levelConfig.labelKey}Name`
  )
 const {
  register,
  control,
  getValues,
  watch,
  setValue,
  handleSubmit,
  formState: {errors},
 } = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
 })

 async function submitFormData(formData: IFormField) {
  if (
   formData?.selectedIds?.length > 0 ||
   level === 'state'
  ) {
   props.setLoader(true)
   const payload = {
    user_id: userId,
    states: levelConfig.usesSelectedIdsAsStates
     ? formData.selectedIds
     : [formData.state],
    ...(['subDistrict', 'district'].includes(level) && {
     districts:
      level === 'subDistrict'
       ? [formData.district]
       : formData.selectedIds,
    }),
    ...(level === 'subDistrict' && {
     subdistricts: formData.selectedIds,
    }),
   }
   const res = await createGeoMapping(payload)
   if (res) {
    toast.success(res)
   }
   props.setLoader(false)
  } else {
   toast.error(t('errors.pleaseSelectDistrict'))
  }
 }

 const getDistrict = async (stateId: number) => {
  setValue('district', '')
  setValue('selectedIds', [])
  setDistrictList([])
  setTableDataList([])
  setTableRows([])
  if (stateId) {
   if (level !== 'state') {
    props.setLoader(true)
    const res: IDropdown[] = await fetchDistrict(stateId)
    if (res) {
     setDistrictList(res)
    }
    props.setLoader(false)
   }
  }
 }

 const handleConfirmBtnClick = async (
  isConfirmed: boolean
 ) => {
  if (isConfirmed) {
   if (confirmModelContent.type === 'state') {
    await getDistrict(confirmModelContent.value)
   } else {
    setValue('selectedIds', [])
    setTableDataList([])
    setTableRows([])
   }
   if (!showLoadMoreBtn) {
    setShowLoadMoreBtn(true)
   }
  } else {
   if (confirmModelContent.type === 'state') {
    if (currentGeoMapping?.states?.length > 0) {
     setValue('state', currentGeoMapping?.states[0].id)
    }
   } else {
    if (currentGeoMapping?.districts?.length > 0) {
     setValue(
      'district',
      currentGeoMapping?.districts[0].id
     )
    }
   }
  }
  setShowConfirmModel(false)
 }

 const handleSearch = (value: string) => {
  if (value) {
   const temp = tableDataList.filter((item) =>
    item.name.toLowerCase().includes(value.toLowerCase())
   )
   setTableRows(temp)
  } else {
   setTableRows(tableDataList)
  }
 }

 const handleDeleteBtnClick = async (
  isConfirm: boolean
 ) => {
  if (isConfirm) {
   const record: ITableData | null = confirmModalData
   if (record) {
    props.setLoader(true)
    const index = tableDataList.findIndex(
     (rec) => rec.id === record.id
    )
    if (index !== -1) {
     tableDataList[index].users = []
     tableDataList[index].is_mapped = false
     const selectedIds = getValues('selectedIds')
     if (selectedIds && selectedIds.length > 0) {
      const indx = selectedIds.findIndex(
       (val: string) => val == record.id
      )
      if (indx !== -1) {
       selectedIds.splice(indx, 1)
       setValue('selectedIds', selectedIds)
      }
     }
     setTableDataList([...tableDataList])
     setTableRows([...tableDataList])
    }
    setConfirmModalData(null)
    props.setLoader(false)
   }
  } else {
   setConfirmModalData(null)
  }
 }

 const renderTableData = async () => {
  props.setLoader(true)

  const columns: Array<ColumnProps<ITableData>> = [
   {
    key: 'name',
    title: getLevelNameColumnLabel(),
   },
   {
    key: 'currentlyAssignedTo',
    title: t(
     'userManagement.activate.geoMappingManage.currentlyAssignedTo'
    ),
    render: (_, record) => {
     return record?.users?.[0] ? (
      <Link
       target='_blank'
       rel='noreferrer'
       className='w-full text-[#4E83E4] underline'
       to={`/user-details/${record?.users[0]?.id}`}
      >
       {record?.users[0]?.full_name}
      </Link>
     ) : (
      <span className='text-[#C5CED6]'>
       {t(
        'userManagement.activate.geoMappingManage.notAssigned'
       )}
      </span>
     )
    },
   },
   ...(!isDisabled
    ? [
       {
        key: 'action',
        title: t(
         'userManagement.activate.geoMappingManage.action'
        ),
        className: '!text-center',
        render: (
         _: ColumnProps<ITableData>,
         record: ITableData
        ) => {
         const disabled = record?.users?.[0]?.id
          ? record?.users?.[0]?.id !== Number(userId)
          : false
         const isAdded =
          disabled ||
          (watch(`selectedIds`).length > 0 &&
           watch(`selectedIds`)?.includes(
            record.id.toString()
           ))
         return (
          <div
           key={record.id}
           className='w-full flex justify-center items-center'
          >
           {record.is_mapped ? (
            <Button
             type='button'
             disabled={false}
             onClick={() => {
              void setConfirmModalData(record)
             }}
             color='green'
             className='text-center bg-white 
             !rounded-lg text-[#CC293F] text-xs font-semibold border-none shadow-none'
            >
             <i
              className='fa fa-trash text-lg font-normal'
              aria-hidden='true'
             ></i>
             <span className='ml-2 pt-1'>
              {t('userManagement.activate.remove')}
             </span>
            </Button>
           ) : (
            <div
             className={`${
              disabled && 'text-[#C5CED6] border-[#E6EBF0]'
             } flex justify-center items-center w-[118px] h-12 rounded-lg border border-[#4E83E4] cursor-pointer text-[#4E83E4] font-semibold text-center
      shadow-[0_4px_4px_0_rgba(0, 0, 0, 0.12)] bg-white px-1 py-[3px]`}
            >
             <CheckboxField
              type='checkbox'
              disabled={disabled}
              label={''}
              checked={isAdded}
              className={`activate-user-checkbox w-5 h-5 mt-1 text-blue-600 bg-gray-100 rounded border-gray-300 border-neutral-30`}
              wrapperClassName=''
              value={record.id.toString()}
              name={`selectedIds`}
              id={`selectedIds-${record.id}`}
              register={register(`selectedIds`, {
               required: false,
              })}
             />
             <span
              className={`${
               disabled && 'text-[#C5CED6]'
              } text-base font-semibold ml-1`}
             >
              {isAdded
               ? t(
                  'userManagement.activate.geoMappingManage.added'
                 )
               : t(
                  'userManagement.activate.geoMappingManage.add'
                 )}
             </span>
            </div>
           )}
          </div>
         )
        },
       },
      ]
    : []),
  ]
  setTableColList(columns)
  props.setLoader(false)
 }

 const loadRbmStateTableData = async (
  existingStates: ITableData[] = []
 ) => {
  props.setLoader(true)
  const data: ITableData[] =
   (await fetchAssignedStateList(props.userRole)) || []
  const tableData = [...data]
  let selectedIds = data
   .filter(
    (val) =>
     val?.users &&
     val.users.some((user) => user.id === Number(userId))
   )
   .map((item) => item.id.toString())

  if (existingStates.length > 0) {
   existingStates.forEach((existing) => {
    const index = tableData.findIndex(
     (row) => row.id === existing.id
    )
    if (index !== -1) {
     tableData[index] = {...tableData[index], ...existing}
    } else {
     tableData.push(existing)
    }
   })
   selectedIds = existingStates
    .filter(
     (val) =>
      val?.users &&
      val.users.some((user) => user.id === Number(userId))
    )
    .map((item) => item.id.toString())
  }

  setValue('selectedIds', selectedIds)
  setTableDataList(tableData)
  setTableRows(tableData)
  props.setLoader(false)
  await renderTableData()
 }

 const loadTableData = async (isNew: boolean) => {
  props.setLoader(true)
  if (showAddNewBtn) {
   setShowAddNewBtn(false)
  }
  let tableRows = [...tableDataList]
  let selectedIds = getValues('selectedIds')
  if (isNew) {
   tableRows = []
   selectedIds = []
   setValue('selectedIds', [])
  }
  let data: ITableData[]
  if (level === 'subDistrict') {
   const districtId = parseInt(getValues('district'))
   data = await fetchAssignedSubDistrictList(
    districtId,
    props.userRole
   )
  } else {
   const stateId = parseInt(getValues('state'))
   data = await fetchAssignedDistrictList(
    stateId,
    props.userRole
   )
  }
  if (data) {
   const assigendForOthers = data.filter(
    (val) => !selectedIds.includes(val.id.toString())
   )
   setTableDataList([...tableRows, ...assigendForOthers])
   setTableRows([...tableRows, ...assigendForOthers])
  }
  props.setLoader(false)
  await renderTableData()
 }

 const handleChangeEvent = async (
  type: string,
  value: number
 ) => {
  if (showLoadMoreBtn) {
   if (type === 'state') {
    await getDistrict(value)
   }
  } else {
   if (type === 'state') {
    setConfirmModelContent({
     title: t(
      'userManagement.activate.geoMappingManage.changeStateTitle'
     ),
     msg: t(
      'userManagement.activate.geoMappingManage.changeStateSubTitle'
     ),
     msgSub:
      level === 'district'
       ? t(
          'userManagement.activate.geoMappingManage.changeDistrictMsg'
         )
       : t(
          'userManagement.activate.geoMappingManage.changeSubDistrictMsg'
         ),
     type,
     value,
    })
   } else {
    setConfirmModelContent({
     title: t(
      'userManagement.activate.geoMappingManage.changeDistrictTitle'
     ),
     msg: t(
      'userManagement.activate.geoMappingManage.changeDistrictSubTitle'
     ),
     msgSub: t(
      'userManagement.activate.geoMappingManage.changeSubDistrictMsg'
     ),
     type,
     value,
    })
   }
   setShowConfirmModel(true)
  }
 }

 const getGeoMapping = async () => {
  props.setLoader(true)
  const res: IFormField | null = await fetchGeoMapping({
   user_id: userId,
  })
  if (levelConfig.autoLoadAssignedList) {
   setCurrentGeoMapping(res)
   const mappedStates = (res?.states ?? []).map(
    (val: ITableData) => {
     return {
      ...val,
      is_mapped: true,
      users: [props.userDetails],
     }
    }
   )
   await loadRbmStateTableData(mappedStates)
   props.setLoader(false)
   return
  }
  if (res) {
   let assigendForOwn: string[] = []
   let existingMapping: ITableData[] = []
   setCurrentGeoMapping(res)
   if (res?.states?.length > 0) {
    setValue('state', res.states[0].id)
    if (['subDistrict', 'district'].includes(level)) {
     await getDistrict(res.states[0].id)
     if (res?.districts?.length > 0) {
      if (level === 'subDistrict') {
       setValue('district', res.districts[0].id)
       if (res?.subdistricts?.length > 0) {
        existingMapping = res.subdistricts.map(
         (val: ITableData) => {
          return {
           ...val,
           is_mapped: true,
           users: [props.userDetails],
          }
         }
        )
       }
      } else {
       existingMapping = res.districts.map(
        (val: ITableData) => {
         return {
          ...val,
          is_mapped: true,
          users: [props.userDetails],
         }
        }
       )
      }
     }
     assigendForOwn = existingMapping
      .filter(
       (val) =>
        val?.users &&
        val.users.some((user) => user.id === Number(userId))
      )
      .map((item) => item.id.toString())
     setValue('selectedIds', assigendForOwn)
     setTableDataList([...existingMapping])
     setTableRows([...existingMapping])
     await renderTableData()
     //
    }
    setShowAddNewBtn(true)
   }
  }
  props.setLoader(false)
 }

 useEffect(() => {
  if (!levelConfig.showStateDropdown) {
   return
  }
  const getState = async () => {
   props.setLoader(true)
   const res: IDropdown[] = await fetchState()
   if (res) {
    setStateList(res)
   }
   props.setLoader(false)
  }
  void getState()
 }, [levelConfig.showStateDropdown, props.userRole])

 useEffect(() => {
  void getGeoMapping()
 }, [props.userDetails])

 useEffect(() => {
  void renderTableData()
 }, [tableRows, isDisabled])

 useEffect(() => {
  handleSearch(searchTerm)
 }, [searchTerm])

 const handleEditBtnClick = () => {
  if (props.accessDetails?.activationFlow?.canEdit) {
   setIsDisabled(false)
  }
 }

 return (
  <>
   {confirmModalData && (
    <KTConfirmPopup
     showConfirmModel={confirmModalData ? true : false}
     handleConfirmBtnClick={handleDeleteBtnClick}
     yesBtnText={t('common.yes')}
     noBtnText={t('common.no')}
     title={t('common.confirmModalTitle')}
     subTitle={`${t('common.deleteConfirmModalSubTitle')} ${
      confirmModalData.name
     }?`}
    />
   )}
   <Model
    show={showConfirmModel}
    showHeader={false}
    closeBtnClass='absolute right-4 top-2 !bg-[#E6EBF0] !rounded-3xl w-7 h-7 !text-[#33393D]'
    header={''}
    close={() => {
     void handleConfirmBtnClick(false)
    }}
    modelClass='md:w-[600px]'
    modelContainerClass='!rounded-2xl'
    modelBodyClass='p-10'
   >
    <div className='w-full'>
     <div className='w-full'>
      <p className='text-[#171B1F] text-left font-bold text-2xl'>
       {confirmModelContent.title}
      </p>
      <div className='text-[#33393D] text-left my-7'>
       <p className='font-medium text-xl'>
        {confirmModelContent.msg}
       </p>
       <p className='font-normal text-base'>
        {confirmModelContent.msgSub}
       </p>
      </div>
      <div className='grid md:grid-cols-2 gap-5 w-full'>
       <Button
        type='button'
        disabled={false}
        onClick={() => {
         void handleConfirmBtnClick(false)
        }}
        color='green'
        className='text-center py-[9px] px-6 bg-[#0E7A41] 
               !rounded-lg text-base text-white font-semibold border-[#0E7A41]'
       >
        {t('common.no')}
       </Button>
       <Button
        type='button'
        disabled={false}
        onClick={() => {
         void handleConfirmBtnClick(true)
        }}
        color='green'
        className='text-center py-[9px] px-6 bg-[#CC293F] 
               !rounded-lg text-base text-white font-semibold border-[#CC293F]'
       >
        {t('common.yes')}
       </Button>
      </div>
     </div>
    </div>
   </Model>
   <div className='w-full'>
    <form
     method='POST'
     action=''
     onSubmit={handleSubmit(submitFormData)}
    >
     <div className='text-[#171B1F] flex justify-between text-lg font-normal'>
      <div>
       {t('userManagement.activate.geoMappingManage.title')}
      </div>
      {(tableDataList?.length >= 0 ||
       level === 'state' ||
       level === 'rbmState') &&
       props.accessDetails?.activationFlow?.canEdit &&
       (isDisabled ? (
        <Button
         key={'edit'}
         type='button'
         disabled={false}
         onClick={handleEditBtnClick}
         color='blue'
         className='text-center py-[9px] px-6 hover:bg-[#4E83E4] w-[85px]
               !rounded-lg text-base text-[#4E83E4] hover:text-white font-semibold border-[#4E83E4]'
        >
         {t('common.edit')}
        </Button>
       ) : (
        <Button
         key={'save'}
         type='submit'
         disabled={false}
         color='blue'
         className='text-center py-[9px] px-6 bg-[#4E83E4] 
               !rounded-lg text-base text-white font-semibold border-[#4E83E4]'
        >
         {t('common.save')}
        </Button>
       ))}
     </div>
     <div className='grid md:grid-cols-3 gap-5 w-full my-6 text-[#171B1F]'>
      {levelConfig.showStateDropdown && (
       <Select2DropdownField
        label={t(
         'userManagement.activate.geoMappingManage.state'
        )}
        labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
        className={`${
         isDisabled
          ? '!text-[#33393D] font-medium '
          : 'font-normal !text-[#33393D]'
        } boxed-select2 relative block text-lg border-0  !rounded-l-lg`}
        wrapperClassName='relative w-full'
        inputWrapperClassName='pl-4 py-2 px-4 '
        required={true}
        disabled={isDisabled}
        isClearable={false}
        isSearchable={true}
        control={control}
        customStyle={{
         transition: 'unset',
         boxShadow: 'unset',
         border: '0px',
         borderRadius: '0px',
         padding: '0px 0px 0px 0px',
         minHeight: 'auto',
        }}
        data={stateList}
        rules={{
         validate: {
          required: (v: string) => {
           if (v === '')
            return `${t('helperText.plsSelect')} ${t(
             'userManagement.activate.geoMappingManage.state'
            )}`
          },
         },
         onChange: (e: {target: {value: number}}) => {
          void handleChangeEvent('state', e.target.value)
         },
        }}
        id={`state`}
        name={`state`}
        OptionValueKey='id'
        OptionLabelKey='name'
        placeholder={`${t('helperText.select')} ${t(
         'userManagement.activate.geoMappingManage.state'
        )}`}
        errors={errors}
       />
      )}

      {levelConfig.showDistrictDropdown && (
       <Select2DropdownField
        label={t(
         'userManagement.activate.geoMappingManage.district'
        )}
        labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
        className={`${
         isDisabled
          ? '!text-[#33393D] font-medium '
          : 'font-normal !text-[#33393D]'
        } boxed-select2 relative block text-lg border-0  !rounded-l-lg`}
        wrapperClassName='relative w-full'
        inputWrapperClassName='pl-4 py-2 px-4 '
        required={true}
        disabled={isDisabled}
        isClearable={false}
        isSearchable={true}
        control={control}
        customStyle={{
         transition: 'unset',
         boxShadow: 'unset',
         border: '0px',
         borderRadius: '0px',
         padding: '0px 0px 0px 0px',
         minHeight: 'auto',
        }}
        data={districtList}
        rules={{
         validate: {
          required: (v: string) => {
           if (v === '')
            return `${t('helperText.plsSelect')} ${t(
             'userManagement.activate.geoMappingManage.district'
            )}`
          },
         },
         onChange: (e: {target: {value: number}}) => {
          void handleChangeEvent('district', e.target.value)
         },
        }}
        id={`district`}
        name={`district`}
        OptionValueKey='id'
        OptionLabelKey='name'
        placeholder={`${t('helperText.select')} ${t(
         'userManagement.activate.geoMappingManage.district'
        )}`}
        errors={errors}
       />
      )}
      {levelConfig.showLoadButton && showLoadMoreBtn && (
       <Button
        type='button'
        disabled={
         !watch(
          level === 'subDistrict' ? 'district' : 'state'
         )
        }
        onClick={() => {
         void loadTableData(true)
        }}
        color='white'
        className='my-2 text-center py-[9px] px-6 bg-white
                        !rounded-lg text-base text-[#4E83E4] font-semibold border-[#4E83E4] disabled:!text-[#C5CED6] disabled:hover:!text-[#C5CED6] disabled:!bg-white'
       >
        {level === 'subDistrict'
         ? t(
            'userManagement.activate.geoMapping.loadSubDistrict'
           )
         : t(
            'userManagement.activate.geoMapping.loadDistrict'
           )}
       </Button>
      )}
     </div>
     {tableDataList.length > 0 && (
      <div className='w-full'>
       <div className='text-[#171B1F] text-lg font-normal'>
        {getLevelLabel()}
       </div>
       <KTSearchBox
        label={t('userManagement.activate.search')}
        placeholder={getLevelLabel()}
        wrapperClass='my-6 !p-3'
        setSearchTerm={setSearchTerm}
       />
       <div className='w-full'>
        <KTTable
         data={tableRows}
         columns={tableColList}
         headerClass='bg-[#80868C]'
         headerColClass='!border-0 text-left'
         colClass='text-[#33393D] !text-sm font-normal !border-0'
         tableClass=''
         rowClass='even:bg-[#E6EBF0]'
         showPagination={false}
        />
        {!isDisabled &&
         levelConfig.showLoadButton &&
         showAddNewBtn && (
          <div className='border-[#E6EBF0] border-[0.5px] py-3 px-4 flex items-center w-full'>
           <div
            className='flex text-[#4E83E4] text-base font-medium items-center cursor-pointer'
            onClick={() => {
             void loadTableData(false)
            }}
           >
            <KTSVG
             path={`/media/icons/plus.svg`}
             svgClassName={`w-5 h-5`}
            />
            <div>
             {t('common.addNew') + ' '}
             {level === 'subDistrict'
              ? t(
                 'userManagement.activate.geoMappingManage.subDistrict'
                )
              : t(
                 'userManagement.activate.geoMappingManage.district'
                )}
            </div>
           </div>
          </div>
         )}
       </div>
      </div>
     )}
    </form>
   </div>
  </>
 )
}

export default GeographyMapping
